// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__5ijNA","smol":"styles_smol__3YVeW"};